export const calculateGameTime = (event, previousTime, numberToAdd) => {
    if (event.liveGameState) {
        event.liveGameState.gameTime = event.liveGameState.clockDirection === "Stopwatch" ? previousTime + numberToAdd : previousTime - numberToAdd;
        return event.liveGameState.gameTime;
    }
    return 0;
};
//# sourceMappingURL=calculateGameTime.js.map